module.exports = __webpack_public_path__ + "img/vn_qrcode_zalo.ba5b5db.png";